module.exports = __webpack_public_path__ + "img/post-cmt-white.2ebc464d.svg";